var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLockWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.367,
    height: 14.919,
    viewBox: "0 0 11.367 14.919",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_lock_24px",
    d: "M13.946,5.973h-.71V4.552a3.552,3.552,0,0,0-7.1,0V5.973h-.71A1.425,1.425,0,0,0,4,7.394v7.1a1.425,1.425,0,0,0,1.421,1.421h8.525A1.425,1.425,0,0,0,15.367,14.5v-7.1A1.425,1.425,0,0,0,13.946,5.973ZM9.683,12.367A1.421,1.421,0,1,1,11.1,10.946,1.425,1.425,0,0,1,9.683,12.367Zm2.2-6.394h-4.4V4.552a2.2,2.2,0,0,1,4.4,0Z",
    transform: "translate(-4 -1)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLockWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_lock_white.19eb32fa5a28c8567268be1119617856.svg";